import { css } from '@emotion/react';

export const modal = css`
  & .MuiPaper-root {
    border-radius: 24px;
    min-width: 280px;
    min-height: 173px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
